"use client";

import "@splidejs/splide/dist/css/splide-core.min.css";

import { CallToActionParagraph } from "@/components/paragraphs/CallToActionParagraph";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface InternalApplicationProcessProps {
  locale: AllowedLanguages;
}

export const InternalApplicationProcess = ({
  locale,
}: InternalApplicationProcessProps) => {
  const { t } = useTranslation(locale);
  const data = {
    __typename: "ParagraphCallToAction" as const,
    id: "-1.internal-component-usage-InternalApplicationProcess",
    status: true,
    title: t(
      "components.internal_application_process.process.call_to_action.title",
    ),
    paragraphCallToActionText: {
      processed: t(
        "components.internal_application_process.process.call_to_action.text",
      ),
    },
    paragraphCallToActionLink: {
      url: t(
        "components.internal_application_process.process.call_to_action.link.url",
      ),
      title: t(
        "components.internal_application_process.process.call_to_action.link.text",
      ),
      internal: true,
    },
    entity_type_behaviors: {
      margin: null,
      box_display: null,
      background_color: "yellow",
    },
    label: null,
    paragraphCallToActionLink2: null,
  };
  return (
    <>
      <CallToActionParagraph data={data} className="rounded" />
    </>
  );
};
